import { render, staticRenderFns } from "./GChatFileMessage.vue?vue&type=template&id=2c95785d&scoped=true&"
import script from "./GChatFileMessage.vue?vue&type=script&lang=ts&"
export * from "./GChatFileMessage.vue?vue&type=script&lang=ts&"
import style0 from "./GChatFileMessage.vue?vue&type=style&index=0&id=2c95785d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95785d",
  null
  
)

export default component.exports